<div style="height: 80vh; width: 80vw; display: flex">
	<iframe
		[src]="supportSiteIframe | trustedContent: 'resourceUrl'"
		title="Support Site Iframe"
	></iframe>
</div>
